import ApplicationSerializer from 'cio/serializers/application';

export default class SsoConfigurationSerializer extends ApplicationSerializer {
  normalize(type: any, hash: any, prop: any) {
    // SSO configurations don't come with an ID, so we add one
    if (hash) {
      hash.id = 'current';
    }

    return super.normalize(type, hash, prop);
  }
}
